import { track } from '../facade';
export const trackVideoState = state => track('Video', { action: state });




// WEBPACK FOOTER //
// ./src/client/js/analytics/category/video.js